//gasp scroll effect
(()=> {
    const els = document.querySelectorAll('.mylo_color_section');
    els.forEach(el => {
        let color = el.dataset.color;
        console.log(color);
        gsap.to('body', {
            backgroundColor:color,
            scrollTrigger: {
                trigger:el,
                start:'top center',
                end:'bottom center',
                toggleActions:'play pause resume reset'
            }
        })
    })
})();
ScrollTrigger.create({
    trigger: '.tk_mylo_lp_white_bg',
    start: 'top center',
    end: 'bottom center',
    toggleClass: {targets: ".tk_mylo_lp_white_bg .tk_mylo_lp_h2,.tk_mylo_lp_white_bg .tk_mylo_lp_txt,.tk_mylo_lp_white_bg .tk_mylo_lp_product_txt", className: "is_black"}
});
ScrollTrigger.create({
    trigger: '.tk_mylo_lp_white_bg',
    start: 'top center',
    end: 'bottom center',
    toggleClass: {targets: ".tk_mylo_lp_white_bg .tk_mylo_lp_product_title", className: "is_green"}
});
ScrollTrigger.create({
    trigger: '.tk_mylo_lp_store',
    start: 'top center',
    end: 'bottom center',
    toggleClass: {targets: ".tk_mylo_lp_store .tk_mylo_lp_h2,.tk_mylo_lp_store .tk_mylo_lp_txt", className: "is_black"}
});
ScrollTrigger.create({
    trigger: '.tk_mylo_lp_notice',
    start: 'top center',
    end: 'bottom center',
    toggleClass: {targets: ".tk_mylo_lp_notice .tk_mylo_lp_h2,.tk_mylo_lp_notice .tk_mylo_lp_txt", className: "is_white"}
});
ScrollTrigger.create({
    trigger: '.tk_mylo_lp_waitlist',
    start: 'top center',
    end: 'bottom+=200 top',
    toggleClass: {targets: ".tk_mylo_lp_waitlist .tk_mylo_lp_h2,.tk_mylo_lp_waitlist .tk_mylo_lp_txt", className: "is_white"}
});

//image effect
function BlurTextAnimeControl() {
    $('.blurTrigger').each(function(){
    var elemPos = $(this).offset().top-50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('blur');
    }else{
    $(this).removeClass('blur');
    }
    });
}

$(window).scroll(function () {
    BlurTextAnimeControl();
});

$(window).on('load', function () {
BlurTextAnimeControl();
});

//text effect
function slideAnime(){
    $('.leftAnime').each(function(){
        var elemPos = $(this).offset().top-100;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
        $(this).addClass("slideAnimeLeftRight");
        $(this).children(".leftAnimeInner").addClass("slideAnimeRightLeft");
        }else{
        $(this).removeClass("slideAnimeLeftRight");
        $(this).children(".leftAnimeInner").removeClass("slideAnimeRightLeft");
        }
    });
}

$(window).scroll(function (){
slideAnime();
});

$(window).on('load', function(){
slideAnime();
});
